import { GetVendorsParams, ICreateInventoryVendorResponse, IEditInventoryVendorResponse, IInventoryVendorPayload, InventoryVendorListResponse } from "../../../features/inventoryManagement/vendors/types";
import ApiService from "../../ApiService";

enum InventoryVendorEndpoints {
    URL = "/inventory-vendors",
}

class InventoryVendorService extends ApiService {
    async getVendors(
        params?: GetVendorsParams
    ): Promise<InventoryVendorListResponse> {
        const queryParams = new URLSearchParams();

        // Pagination Params
        if (params?.page) queryParams.append("page", String(params.page));
        if (params?.size) queryParams.append("size", String(params.size));

        // Filter Params
        // Status check for 'undefined' to allow 0 to be passed
        if (params?.status !== undefined)
            queryParams.append("status", String(params.status));
        if (params?.search_keyword)
            queryParams.append("search_keyword", params.search_keyword);

        const queryString = queryParams.toString();
        const url = `${InventoryVendorEndpoints.URL}${queryString ? `?${queryString}` : ""}`;

        return this.get<InventoryVendorListResponse>(url);
    }

    async saveOrUpdateInventoryVendor(formData: FormData): Promise<ICreateInventoryVendorResponse> {
        const id = formData.get("id");
        const url = id ? `${InventoryVendorEndpoints.URL}/${id}` : InventoryVendorEndpoints.URL;
        return this.post<ICreateInventoryVendorResponse>(url, formData);
    }

    async getEditInventoryVendor(id: number): Promise<IEditInventoryVendorResponse> {
        return this.get<IEditInventoryVendorResponse>(`${InventoryVendorEndpoints.URL}/${id}`);
    }
}

export const inventoryVendorService = new InventoryVendorService();